import { render, staticRenderFns } from "./FormCheck.vue?vue&type=template&id=15febbe3&scoped=true"
import script from "./FormCheck.vue?vue&type=script&lang=js"
export * from "./FormCheck.vue?vue&type=script&lang=js"
import style0 from "./FormCheck.vue?vue&type=style&index=0&id=15febbe3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15febbe3",
  null
  
)

export default component.exports